import {
  aboutPickupSupportUrl,
  aboutDeliverySupportUrl,
  aboutSwapSupportUrl,
  aboutReturnSupportUrl,
  supportHomeUrl,
} from '@/catalog/constants/support-urls';
import DirectoryLinkBlock from './directory-link-block';
import { useDisableSpaNavigation } from '@/util-react-router/hooks/use-disable-spa-navigation';

const flexcarSectionLinks = (disableSpaNavigation: boolean) => [
  { text: 'FAQ', to: '/how-it-works#faq', reloadDocument: disableSpaNavigation },
  { text: 'Inventory', to: '/inventory' },
  {
    text: 'The Flextra Mile',
    to: 'https://blog.flexcar.com/',
  },
  {
    text: 'Careers',
    to: 'https://careers.flexcar.com/',
  },
];

const supportSectionLinks = () => [
  {
    text: 'Pickups',
    to: aboutPickupSupportUrl,
  },
  {
    text: 'Delivery',
    to: aboutDeliverySupportUrl,
  },
  {
    text: 'Swaps',
    to: aboutSwapSupportUrl,
  },
  {
    text: 'Returns',
    to: aboutReturnSupportUrl,
  },
  { text: 'Help center', to: supportHomeUrl },
];

export default function FlexcarAndSupportLinks() {
  const { disableSpaNavigation } = useDisableSpaNavigation();

  return (
    <div className="flex gap-[48px]">
      <DirectoryLinkBlock
        title="Flexcar"
        links={flexcarSectionLinks(disableSpaNavigation)}
      />
      <DirectoryLinkBlock title="Support" links={supportSectionLinks()} />
    </div>
  );
}
